import { styled } from '@mui/material/styles';
import capitalize from 'lodash/capitalize';
import { FC, useCallback } from 'react';
import { moneyFormat } from '../../shared/utils/functions';

type SliderLabelProps = {
  value: number;
  index: number;
  measurementUnit: string;
  isRangeSlider: boolean;
  getMoneyDiscount: (value: number) => number;
  label?: string;
};

type SliderValueProps = {
  noMoneyDiscount: boolean;
};

const SliderLabelContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginLeft: theme.spacing(0.5),
}));

const MoneyDiscount = styled('span')(
  ({
    theme: {
      palette: { primary },
      spacing,
    },
  }) => ({
    padding: '0 10px',
    marginTop: spacing(0.5),
    fontSize: 14,
    width: 'max-content',
    color: `${primary.main} !important`,
  }),
);

const SliderValue = styled('span', {
  shouldForwardProp: (prop) => prop !== 'noMoneyDiscount',
})<SliderValueProps>(({ theme, noMoneyDiscount }) => ({
  transform: noMoneyDiscount ? `translateY(${theme.spacing(1)})` : 'unset',
}));

const SliderLabel: FC<SliderLabelProps> = ({
  value,
  index,
  measurementUnit,
  getMoneyDiscount,
  isRangeSlider,
  label = 'discount:',
}) => {
  const getSliderValue = useCallback(() => {
    if (!measurementUnit) {
      return value;
    }

    if (getMoneyDiscount) {
      if (isRangeSlider) {
        return `${
          index === 0 ? 'Start' : 'End'
        } ${label} ${value}${measurementUnit}`;
      } else {
        return capitalize(`${label} ${value}${measurementUnit}`);
      }
    }

    return isRangeSlider
      ? `${index === 0 ? `Start` : 'End'} ${value}${measurementUnit}`
      : `${value}${measurementUnit}`;
  }, [isRangeSlider, getMoneyDiscount, index, value, measurementUnit, label]);

  const isMoneyDiscountVisible =
    getMoneyDiscount && !isNaN(getMoneyDiscount(value));

  return (
    <SliderLabelContainer>
      <SliderValue noMoneyDiscount={!isMoneyDiscountVisible}>
        {getSliderValue()}
      </SliderValue>
      {isMoneyDiscountVisible && (
        <MoneyDiscount>{moneyFormat(getMoneyDiscount(value))}</MoneyDiscount>
      )}
    </SliderLabelContainer>
  );
};

export default SliderLabel;
